export default __webpack_public_path__ + "static/media/Screen Shot 2021-06-20 at 11.50.26 AM.1754bf20.png";